import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useRestaurant } from '../../contexts/RestaurantContext';
import { Menu, Store, Bell } from 'lucide-react';

interface MobileHeaderProps {
  onMenuClick: () => void;
}

const MobileHeader: React.FC<MobileHeaderProps> = ({ onMenuClick }) => {
  const { user } = useAuth();
  const { restaurant } = useRestaurant();

  return (
    <div className="bg-white shadow-sm border-b border-secondary-200 pt-safe">
      <div className="flex h-16 items-center justify-between px-4">
        <div className="flex items-center space-x-3">
          <button
            onClick={onMenuClick}
            className="text-secondary-500 hover:text-secondary-600 p-2 -m-2 rounded-md touch-manipulation"
          >
            <Menu className="h-6 w-6" />
          </button>
          <div className="flex items-center space-x-2">
            <Store className="h-6 w-6 text-primary-600" />
            <div>
              <h1 className="text-lg font-semibold text-secondary-900">
                {restaurant?.nome || 'Restaurante'}
              </h1>
            </div>
          </div>
        </div>

        <div className="flex items-center space-x-3">
          <button className="text-secondary-400 hover:text-secondary-600">
            <Bell className="h-6 w-6" />
          </button>
          <div className="flex items-center space-x-2">
            <div className="h-8 w-8 rounded-full bg-primary-600 flex items-center justify-center">
              <span className="text-sm font-medium text-white">
                {user?.nome?.charAt(0).toUpperCase()}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileHeader;
